export default __webpack_public_path__ + "static/favicon-9d05dc503d96e6d711e2d67cb6aee7d9.ico";